import { useEffect, useState } from "react";

import Sentry from "@similarweb/sentry-logger";

import { proNavigator } from "single-spa/react-app/ProNavigator";

export const useAsyncHref = (stateName: string, params: Record<string, unknown>): string => {
    const paramsKey = JSON.stringify(params);
    const requestKey = `${stateName}:${paramsKey}`;
    const [resolved, setResolved] = useState<{ key: string; href: string } | null>(null);

    useEffect(() => {
        let cancelled = false;

        void proNavigator
            .hrefAsync(stateName, JSON.parse(paramsKey) as Record<string, unknown>)
            .then((url) => {
                if (!cancelled) {
                    setResolved({ key: requestKey, href: url });
                }
            })
            .catch((error: unknown) => {
                Sentry.errorTracker({
                    e: error instanceof Error ? error : new Error(JSON.stringify(error)),
                    message: "Error resolving href",
                    level: "error",
                    params: { extra: { stateName, paramsKey } },
                });
                if (!cancelled) {
                    setResolved({ key: requestKey, href: "" });
                }
            });

        return () => {
            cancelled = true;
        };
    }, [stateName, paramsKey, requestKey]);

    return resolved?.key === requestKey ? resolved.href : "";
};
